export default function initHeader() {
  var header = document.getElementById('header');
  var body = document.body;
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuOpen = document.querySelector('[data-menu-open]');
  var menuClose = document.querySelector('[data-menu-close]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var searchOpeners = document.querySelectorAll('[data-search-open]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var desktopSubmenuToggles = document.querySelectorAll('[data-desktop-submenu-toggle]');
  var mobileSubmenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
  var accountMenu = document.querySelector('[data-account-menu]');
  var accountToggle = document.querySelector('[data-account-toggle]');
  var accountPanel = document.querySelector('[data-account-panel]');
  var unavailableLanguages = document.querySelectorAll('[data-language-unavailable]');
  var announcementTyping = document.querySelector('[data-announcement-typing]');
  var scrollTicking = false;
  var headerIsScrolled = false;
  var headerTransitionLock = false;
  var headerTransitionTimer = null;

  function initAnnouncementTyping() {
    if (!announcementTyping) {
      return;
    }

    var text = announcementTyping.getAttribute('data-text') || '';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      announcementTyping.textContent = text;
      return;
    }

    var characterIndex = 0;

    function typeNextCharacter() {
      announcementTyping.textContent = text.slice(0, characterIndex);

      if (characterIndex < text.length) {
        characterIndex += 1;
        window.setTimeout(typeNextCharacter, 54);
        return;
      }

      window.setTimeout(function () {
        characterIndex = 0;
        announcementTyping.textContent = '';
        window.setTimeout(typeNextCharacter, 360);
      }, 4200);
    }

    typeNextCharacter();
  }

  function setMenu(open) {
    if (!mobileMenu || !menuOpen) {
      return;
    }

    mobileMenu.classList.toggle('is-active', open);
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('is-menu-open', open);

    if (open && menuClose) {
      menuClose.focus({ preventScroll: true });
    } else if (!open) {
      menuOpen.focus({ preventScroll: true });
    }
  }

  function setDrawer(drawer, open) {
    if (!drawer) {
      return;
    }

    drawer.classList.toggle('is-active', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('is-drawer-open', open);

    if (drawer === cartDrawer) {
      cartOpeners.forEach(function (opener) {
        opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (open) {
      var focusTarget = drawer === searchDrawer
        ? drawer.querySelector('[data-product-search-input]')
        : drawer.querySelector('.c-drawer__close, input, button, a');
      if (focusTarget) {
        window.setTimeout(function () {
          focusTarget.focus();
        }, 120);
      }
    } else if (drawer === searchDrawer) {
      document.dispatchEvent(new CustomEvent('crispins:search-drawer-closed'));
    }
  }

  function closeDrawers() {
    setDrawer(searchDrawer, false);
    setDrawer(cartDrawer, false);
  }

  function setAccountMenu(open, returnFocus) {
    if (!accountMenu || !accountToggle || !accountPanel) {
      return;
    }

    accountMenu.classList.toggle('is-open', open);
    accountToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    accountPanel.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (!open && returnFocus) {
      accountToggle.focus();
    }
  }

  if (accountToggle) {
    accountToggle.addEventListener('click', function () {
      setAccountMenu(!accountMenu.classList.contains('is-open'), false);
    });
  }

  if (menuOpen) {
    menuOpen.addEventListener('click', function () {
      setMenu(true);
    });
  }

  if (menuClose) {
    // Avoid the browser's pointer-focus step targeting a control that becomes
    // hidden during the same click. In a sticky header that can scroll the
    // document towards the control's original position.
    menuClose.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    menuClose.addEventListener('click', function (event) {
      event.preventDefault();
      setMenu(false);
    });
  }

  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setMenu(false);
      });
    });
  }

  desktopSubmenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var menuItem = toggle.closest('.header__nav-item');
      var willOpen = !menuItem.classList.contains('is-open');

      document.querySelectorAll('.header__nav-item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var openToggle = openItem.querySelector('[data-desktop-submenu-toggle]');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      });

      menuItem.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  mobileSubmenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var menuItem = toggle.closest('.header__mobile-item');
      var willOpen = !menuItem.classList.contains('is-open');
      var submenuLabel = toggle.getAttribute('data-submenu-label') || '';
      var labelTemplate = toggle.getAttribute(willOpen ? 'data-submenu-hide' : 'data-submenu-show') || '%s';
      menuItem.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', labelTemplate.replace('%s', submenuLabel));
      toggle.textContent = willOpen ? '−' : '+';
    });
  });

  unavailableLanguages.forEach(function (language) {
    language.addEventListener('click', function () {
      var message = language.getAttribute('data-message');

      if (message) {
        window.alert(message);
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (accountMenu && !event.target.closest('[data-account-menu]')) {
      setAccountMenu(false, false);
    }

    if (event.target.closest('.header__nav-item')) {
      return;
    }

    document.querySelectorAll('.header__nav-item.is-open').forEach(function (menuItem) {
      menuItem.classList.remove('is-open');
      var toggle = menuItem.querySelector('[data-desktop-submenu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  searchOpeners.forEach(function (opener) {
    opener.addEventListener('click', function () {
      setDrawer(searchDrawer, true);
    });
  });

  cartOpeners.forEach(function (opener) {
    opener.addEventListener('click', function () {
      setDrawer(cartDrawer, true);
    });
  });

  document.addEventListener('crispins:open-cart', function () {
    setDrawer(cartDrawer, true);
  });

  document.querySelectorAll('[data-drawer-close]').forEach(function (closer) {
    closer.addEventListener('click', function () {
      closeDrawers();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    if (mobileMenu && mobileMenu.classList.contains('is-active')) {
      setMenu(false);
    }

    if (accountMenu && accountMenu.classList.contains('is-open')) {
      setAccountMenu(false, true);
    }

    closeDrawers();
  });

  function updateHeader() {
    if (header) {
      var scrollY = window.scrollY;
      var shouldCompact = headerIsScrolled;

      if (!headerTransitionLock) {
        shouldCompact = headerIsScrolled ? scrollY > 0 : scrollY > 24;
      }

      if (shouldCompact !== headerIsScrolled) {
        headerIsScrolled = shouldCompact;
        header.classList.toggle('is-scrolled', shouldCompact);
        headerTransitionLock = true;

        if (headerTransitionTimer) {
          window.clearTimeout(headerTransitionTimer);
        }

        headerTransitionTimer = window.setTimeout(function () {
          headerTransitionLock = false;
          updateHeader();
        }, 450);
      }
    }
    scrollTicking = false;
  }

  window.addEventListener('scroll', function () {
    if (scrollTicking) {
      return;
    }

    scrollTicking = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  updateHeader();
  initAnnouncementTyping();
}
